export default __webpack_public_path__ + "static/media/icon-content.e288c6b5.svg";